import { getFormValues, actionTypes } from "redux-form";
import { takeEvery, put, select } from "redux-saga/effects";
import { prefix } from "redux-form/lib/actionTypes";
import transformToRide from '../../utils/transformToRide';
import { setNewRideId } from "../actions/currentRide";
import { push } from "../actions/snackbar";
import { set } from "../actions/currentRide";
import { submitFormRoutine as submitFormReservation } from "../actions/formRoutines/reservation";

function* reservationFormChanged() {
  const state = yield select();
  const values = getFormValues("reservation")(state);

  const ride = values ?  transformToRide(values, state?.authorization?.client?.account) : undefined;
  yield put(set(ride));
}

function* saveRideId({ payload: id }) {
  yield put(setNewRideId(id));
  yield put(push("Congratulations!", `Your confirmation number is ${id}`, "info"));
}

function* onFormError({ payload: { errorMessage } }) {
  yield put(push("Submit error", errorMessage, "error"));
}

export default [
  takeEvery(({ type, meta }) => {
    return meta?.form === "reservation" && type.startsWith(prefix) && ![
      actionTypes.BLUR,
      actionTypes.CLEAR_FIELDS,
      actionTypes.DESTROY,
      actionTypes.INITIALIZE,
      actionTypes.REGISTER_FIELD,
      actionTypes.RESET,
    ].includes(type);
  }, reservationFormChanged),
  takeEvery(submitFormReservation.SUCCESS, saveRideId),
  takeEvery(submitFormReservation.FAILURE, onFormError),
];
